import { Boolean } from "./Filter.Controls.Boolean";
import { Interval } from "./Filter.Controls.Interval";
import { MultiSelect } from "./Filter.Controls.MultiSelect";
import { Dropdown } from "./Filter.Controls.Dropdown";
import { Col, Row } from "./Filter.Controls.style";
import { Icon } from "assets/Icons_";
import { _project } from "state/store.projects";
import { getProjectData } from "state/jotai.projectDataHooks";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { MultiSelectCheckbox } from "./Filter.Controls.MultiSelectCheckbox";
import { useEffect, useState } from "react";

const dropdownData = {
  Type: "Dropdown",
  Default: [0],
};

export const Controls = ({ active, options, setFilters }) => {
  const [fOption, setFoption] = useState([])
  const { pin, pid } = useGet(active_project);
  const buttonsLabel =
    getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const iconLookup = getFocus(_project, "IconLookup")?.[pin]?.[pid] ?? [];

  let lookup = {};

  const PossibleValues = getProjectData("unitcategories").map((i, j) => ({
    ID: j,
    Value: !j
      ? buttonsLabel?.filter((btn) => btn?.UILabelProperty === "AlleBoligtyper")[0]
        ?.Label
      : i,
    ValueProperty: "Boligtype",
  }));

  iconLookup?.forEach((icon) => {
    lookup[icon?.Property] = icon?.Label;
  });

  dropdownData.PossibleValues = PossibleValues;
  dropdownData.Label = buttonsLabel?.filter(
    (btn) => btn?.UILabelProperty === "Boligtype"
  )[0]?.Label;

  if (!options.filter((i) => i.Type == "Dropdown").length > 0) {
    options.push(dropdownData);
  }
  
  const typeValues = active?.multiSelect?.find(m => m.property === "Type")?.values ?? [];
  const typeKey = JSON.stringify(typeValues);

useEffect(() => {
  let newOption = options.map(option => ({ ...option }));

  if (typeValues.length) {
    const isStatusO = newOption.filter(m => m.Label === "Status");

    if (isStatusO.length && typeValues.length === 1) {
      // Filter Status possible values
      isStatusO[0].PossibleValues = isStatusO[0].PossibleValues?.filter((pv) => {
        if (typeValues[0] === "SalesTypeEjerlejlighed" && pv.ID === 30) return false;
        else if (typeValues[0] === "SalesTypeLejelejlighed" && pv.ID === 40) return false;
        return true;
      });

      // Filter for prices: husleje / kontantpris
      newOption = newOption.filter((no) => {
        if (typeValues[0] === "SalesTypeEjerlejlighed" && no.FilterFor === "Husleje") return false;
        else if (typeValues[0] === "SalesTypeLejelejlighed" && no.FilterFor === "Kontantpris") return false;
        return true;
      });
    }
  }

  setFoption(newOption);
}, [typeKey, options]); // 👈 only runs when Type selection changes


  return (
    <>
    
      {fOption.map(({ Type, Label, ...i }, j) => {
        const props = { ...i, active, setFilters, key: j, index: j, Label };
        const icon = { icon: lookup[Label], color: clr?.icons, size: 20 };
    

        // not rendering component which have 0 or null values
        if (i.hasOwnProperty("MinValue") && i.hasOwnProperty("MaxValue")) {
          if (!i.MinValue && !i.MaxValue) return null;
        } else {
          if (!i.PossibleValues.length) return null;
        }

        return (
          <Col index={j} key={j}>
            <div
              style={{
                border: "0px solid black",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Icon
                clr={clr}
                {...icon}
                isFaIcon={(icon?.icon === "area" || icon?.icon === "orientation" || icon?.icon === "unit" || icon?.icon === "paw")  ? false : true}
                size={(icon?.icon === "area" || icon?.icon === "orientation" || icon?.icon === "unit" || icon?.icon === "paw") && 16}
              />
              <div style={{ flex: "0 0 5px" }} />
              <div
                style={{
                  position: "relative",
                  color: `${clr.primary_text}`,
                  whiteSpace: "nowrap",
                }}
                className="paragraph1-regular"
              >
                {Label}
              </div>
            </div>
            <Row>
              {Type === "MultiSelect" && <MultiSelectCheckbox {...props} />}
              {Type === "MultiRange" && <Interval {...props} />}
              {Type === "Boolean" && <Boolean {...props} />}
              {Type === "Dropdown" && <Dropdown {...props} />}
            </Row>
          </Col>
        );
      })}
    </>
  );
};
